import company from './company'

export default [
  ...company,
]
